import { Route, Routes } from 'react-router-dom';
import Layout from './Layout';
import { MfaAuth } from './MfaAuth';
import { MfaCompleted } from './MfaCompleted';
import { SecuritySettings } from './SecuritySettings';
import { VerifyMfa } from './VerifyMfa';

export const Security = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route path="/" element={<SecuritySettings />} />
        <Route path="/mfa" element={<MfaAuth />} />
        <Route path="/mfa/verify" element={<VerifyMfa />} />
        <Route path="/mfa/verify/completed" element={<MfaCompleted />} />
      </Route>
    </Routes>
  );
};
